import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import Component from '@glimmer/component';
import t from 'ember-intl/helpers/t';
import { localCopy } from 'tracked-toolbox';

type AdditionalGuestsFieldSignature = {
  Args: {
    guestCount?: number;
    onGuestCountChange?: (n: number) => void;
  };
};

export default class AdditionalGuestsField extends Component<AdditionalGuestsFieldSignature> {
  min = 0;
  max = 99;
  inputId = 'additional-guests-field-input-' + guidFor(this);

  @localCopy('args.guestCount', 0) declare value: number;

  @action
  onInput(event: Event): void {
    const { min, max } = this;

    const target = event.target as HTMLInputElement;
    const newValue = parseInt(target.value, 10) || 0;

    this.value = Math.min(max, Math.max(min, newValue));
    this.args.onGuestCountChange?.(this.value);
  }

  <template>
    <div data-test-mapped-wrapper data-test-field="additional-guests" class="antialiased">
      <div class="mb-2" data-test-label>
        <label class="leading-tight grayDarker text-base" for={{this.inputId}}>
          {{t "additional_guests"}}
        </label>
      </div>
      <input
        id={{this.inputId}}
        data-test-input
        type="number"
        class="rounded-md input"
        min={{this.min}}
        max={{this.max}}
        value={{this.value}}
        {{on "input" this.onInput}}
        {{! disable last pass autofill }}
        data-lpignore="true"
        {{! disable one pass autofill }}
        data-1p-ignore="true"
        {{! disable dashlane autofill }}
        data-form-type="other"
      />
    </div>
  </template>
}
